<template>
  <div class="profile_core">
    <header-animat class="header_title">
      <div class="inner">
        <div class="content">
          <div class="left">
            <header-img :img="headerImg" :model="false"></header-img>
            <div class="nick_name">
              <h4>{{ $store.state.userdata.user.nickName }}</h4>
              <p class="edit_data" @click="handleEditData">
                资料编辑<i class="el-icon-edit"></i>
              </p>
            </div>
          </div>
          <div class="right" @click="scoredeatil">
            <h2>{{ $store.state.userdata.user.score || 0 }}</h2>
            <p>积分</p>
          </div>
        </div>
        <el-dialog
          title="积分明细"
          :visible.sync="dialogVisible"
          width="30%"
          :before-close="handleClose"
        >
          <el-table
            :data="scoreData"
            header-align="center"
            :header-cell-style="scorestyle"
          >
            <el-table-column
              property="createTime"
              align="center"
              label="时间"
            ></el-table-column>
            <el-table-column
              property="eventType"
              align="center"
              label="事件"
            >
              <template slot-scope="{row}">
                <span v-if="row.eventType==1">下 载</span>
                <span v-else-if="row.eventType==2">反 馈</span>
                <span v-else>其 他</span>
              </template>
            </el-table-column>
            <el-table-column
              property="score"
              align="center"
              label="积分变化"
            >
              <template slot-scope="{row}">
                <span v-if="row.score>0">{{'+'+row.score}}</span>
                <span v-else-if="row.score<0">{{row.score}}</span>
                <span v-else>0</span>
              </template>
            </el-table-column>
            <el-table-column
              property="scoreAfter"
              align="center"
              label="当前积分"
            ></el-table-column>
          </el-table>
          <div class="page_box" style="margin-top:20px;">
            <el-pagination
              background
              layout="total, sizes, prev, pager, next"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="pageSize"
              :current="1"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :total="total">
            </el-pagination>
          </div>
        </el-dialog>
        <div class="nav">
          <el-menu
            :default-active="activeIndex"
            class="el-menu-nav"
            mode="horizontal"
            :router="true"
            @select="handleSelect"
            background-color="transparent"
            active-text-color="#50ddbb"
            text-color="#3eb297"
          >
            <el-menu-item index="/profile-core/works">我的作品</el-menu-item>
            <el-menu-item index="/profile-core/collect">我的收藏</el-menu-item>
            <el-menu-item index="/profile-core/upload">上传资料</el-menu-item>
            <el-menu-item index="/profile-core/feedback">我要反馈</el-menu-item>
            <el-menu-item
              v-if="$store.state.userdata.user.supervise == 1"
              index="/profile-core/examine"
              >作品审核</el-menu-item
            >
          </el-menu>
        </div>
      </div>
    </header-animat>
    <router-view></router-view>
  </div>
</template>
<script>
import headerAnimat from '@/components/HeaderAnimat'
import headerImg from '@/components/HeaderAnimat/headerImg'
export default {
    name:'ProfileCore',
    components:{
        headerAnimat,
        headerImg
    },
    data(){
        return{
            activeIndex:'',
            headerImg:'',
            baseurl:this.$http.requrl,
            dialogVisible:false,
            scoreData:[
              {
                date: '2022-1-15',
                name: '上传资源',
                address: '+10',
                score:20
              },
            ],
            scorestyle:{
              background: "#F2F2F2",
              color: "#333333",
            },
            total:0,
            pageSize:10,
            current:1
        }
    },
    watch:{
        $route(to,from){
           this.activeIndex = to.path
        }
    },
    created(){
        this.activeIndex = this.$route.path
        
    },
    mounted(){
        this.headerImg = this.$store.state.userdata.user.avatar
        this.userdata();
    },
    methods:{
        handleSelect(key, keyPath) {
          
            // console.log(key, keyPath);
        },
        handleEditData(){
            this.$router.push({path:'/profile'})
        },
        // 积分明细列表
        scoredeatil(){
            this.dialogVisible = true;
            this.$http.get(`/business/record/list?createId=${this.$store.state.userdata.user.userId}&pageSize=${this.pageSize}&pageNum=${this.current}`).then(res => {
                if (res.code == 200) {
                    this.scoreData = res.rows
                    this.total = res.total
                }
            });
        },
        handleSizeChange(val) {
          this.pageSize = val
          this.scoredeatil()
        },
        handleCurrentChange(val) {
          this.current = val
          this.scoredeatil()
        },
        handleClose(){
            this.dialogVisible = false;
        },
          // 查询用户信息
        userdata() {
            this.$http.get("/system/user/myDetail").then(res => {
                if (res.code == 200) {
                    let usdata = JSON.stringify(res.data);
                    localStorage.setItem("userdata", usdata);
                    if (localStorage.getItem("userdata")) {
                        this.$store.commit('userdata', JSON.parse(localStorage.getItem("userdata")));
                    }

                }
            });
        },
        refreshView() {
          const { fullPath } = this.$route;
          this.$nextTick(() => {
            this.$router.replace({
              path: '/redirect' + fullPath
            })
          })
        }

    }
    
}
</script>
<style lang="scss" scoped>
.profile_core {
  margin-top: 100px;
  min-height: calc(100vh - 100px);
  background: #fff;
  min-width: 1240px;
  padding-bottom: 20px;
  ::v-deep {
    .portrait {
      padding-bottom: 0;
    }
    .el-menu.el-menu--horizontal {
      border-bottom: none;
      width: 100%;
      display: flex;
      justify-content: space-between;
    }
    .el-menu-item {
      margin: 0 0px;
      font-size: 18px;
      background-color: transparent !important;
    }
    .el-menu--horizontal > .el-menu-item.is-active {
      border-bottom-width: 4px;
    }
  }
}
.nav {
  display: flex;
  justify-content: center;
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 680px;
  transform: translateX(-50%);
}
.header_title{
  position: relative;
}
.header_title .content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #ffffff;
  padding-bottom: 54px;
  
  .left {
    display: flex;
    align-items: center;
    .nick_name {
      margin-left: 21px;
      h4 {
        font-size: 24px;
        font-weight: 400;
        margin-bottom: 21px;
        line-height: 1;
      }
      p {
        font-size: 16px;
        font-weight: 400;
        line-height: 1;
        cursor: pointer;
        transition: all 0.2s;
        &:hover {
          color: rgb(71, 132, 221);
        }
      }
    }
  }
  .right {
    text-align: center;
    cursor: pointer;
    h2 {
      font-size: 46px;
      font-family: DINPro;
      font-weight: bold;
      line-height: 1;
      margin-bottom: 14px;
    }
    p {
      font-size: 16px;
      line-height: 1;
    }
  }
}
</style>